export const personalInfo = {
  name: "canervac",
  fullName: "Caner",
  role: "Grafik Tasarımcısı & Yazılım Geliştiricisi",
  bio: "Merhaba! Ben Caner. 20 yaşındayım. Grafik tasarım ve yazılımla ilgileniyorum. Sezgisel tasarımlar ve projeler yapıyorum. Part-time geliştirici olarak kendi projelerim üzerinde çalışıyor ve sürekli yeni şeyler öğrenmeye çalışıyorum.",
  shortBio: "Grafik tasarım ve yazılımla ilgileniyorum, sezgisel tasarımlar ve projeler yapıyorum.",
  avatar: "https://www.canervac.com.tr/_next/image?url=%2Fimages%2Favatar.png&w=3840&q=75",
  email: "canervac@proton.me",
  github: "https://github.com/canervac",
  location: "Türkiye",
  birthYear: 2005,
  experienceStart: 2023,
  musicSite: "https://canervac-music.vercel.app/",
  socials: {
    instagram: "https://instagram.com/canervac",
    youtube: "https://youtube.com/@canervac",
    spotify: "https://open.spotify.com/user/canervac",
    twitter: "https://twitter.com/canervac"
  }
};

export const greetings = [
  { text: "Merhaba", lang: "Türkçe", flag: "🇹🇷", code: "tr" },
  { text: "Hello", lang: "English", flag: "🇬🇧", code: "en" },
  { text: "Bonjour", lang: "Français", flag: "🇫🇷", code: "fr" },
  { text: "Hallo", lang: "Deutsch", flag: "🇩🇪", code: "de" },
  { text: "Hola", lang: "Español", flag: "🇪🇸", code: "es" },
  { text: "Ciao", lang: "Italiano", flag: "🇮🇹", code: "it" },
  { text: "こんにちは", lang: "日本語", flag: "🇯🇵", code: "jp" },
  { text: "안녕하세요", lang: "한국어", flag: "🇰🇷", code: "kr" },
  { text: "你好", lang: "中文", flag: "🇨🇳", code: "cn" },
  { text: "Привет", lang: "Русский", flag: "🇷🇺", code: "ru" },
  { text: "Olá", lang: "Português", flag: "🇵🇹", code: "pt" },
  { text: "Hej", lang: "Svenska", flag: "🇸🇪", code: "se" },
  { text: "مرحبا", lang: "العربية", flag: "🇸🇦", code: "ar" },
  { text: "Γεια σου", lang: "Ελληνικά", flag: "🇬🇷", code: "gr" },
  { text: "Cześć", lang: "Polski", flag: "🇵🇱", code: "pl" },
  { text: "Xin chào", lang: "Tiếng Việt", flag: "🇻🇳", code: "vn" },
  { text: "Hei", lang: "Norsk", flag: "🇳🇴", code: "no" },
  { text: "Hoi", lang: "Nederlands", flag: "🇳🇱", code: "nl" },
  { text: "Ahoj", lang: "Čeština", flag: "🇨🇿", code: "cz" },
  { text: "Salut", lang: "Română", flag: "🇷🇴", code: "ro" }
];

export const projects = [
  {
    id: 1,
    title: "Basit Ve Modern Ders Çalışma Programı",
    description: "Kullanıcı dostu basit kullanımı ile hazırlanmış ders çalışma, planlama web sitesi. Öğrenciler için tasarlanmış modern arayüz.",
    image: "https://www.canervac.com.tr/_next/image?url=%2Fimages%2Fprojects%2Fproject-01%2Fstudent1.PNG&w=3840&q=75",
    liveUrl: "https://vacstudent.vercel.app/",
    category: "Web Geliştirme",
    tags: ["React", "Next.js", "Tailwind", "Vercel"],
    year: 2024,
    featured: true
  },
  {
    id: 2,
    title: "Etrafa Bakan Göz Müzik Görselleştirmesi",
    description: "Müzik ritmine göre hareket eden göz bebeği derin duygular uyandırıyor. After Effects ile oluşturulmuş etkileyici görsel.",
    image: "https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?w=800&q=80",
    liveUrl: "https://www.youtube.com/watch?v=TGBEHJ0spso",
    category: "Grafik Tasarım",
    tags: ["After Effects", "Motion Graphics", "Audio Visualization"],
    year: 2024,
    featured: true
  },
  {
    id: 3,
    title: "Grafik Tasarım Çalışmaları",
    description: "3D ve farklı materyaller kullanarak kendimi her çalışmamda geliştirmeye çalıştığım profesyonel tasarım projeleri.",
    image: "https://www.canervac.com.tr/_next/image?url=%2Fimages%2Fprojects%2Fproject-01%2Fcanervac1.png&w=3840&q=75",
    liveUrl: null,
    category: "Grafik Tasarım",
    tags: ["3D", "Photoshop", "Illustrator", "Blender"],
    year: 2024,
    featured: false
  },
  {
    id: 4,
    title: "Modern Spotify Destekli Kişisel Website",
    description: "TypeScript ile hazırladığım sade ve modern ve Spotify destekli gelişmiş kişisel web sitesi.",
    image: "https://www.canervac.com.tr/_next/image?url=%2Fimages%2Fprojects%2Fproject-01%2Fwebsitesi1.png&w=3840&q=75",
    liveUrl: "https://canervrs.vercel.app/",
    category: "Web Geliştirme",
    tags: ["TypeScript", "Next.js", "Spotify API", "Tailwind"],
    year: 2024,
    featured: true
  }
];

export const repositories = [
  {
    id: 1,
    name: "canervac",
    description: "Kişisel web sitesi kaynak kodları - Modern ve minimalist tasarım",
    language: "TypeScript",
    stars: 21,
    forks: 3,
    isPublic: true,
    url: "https://github.com/canervac/canervac",
    topics: ["portfolio", "nextjs", "typescript"]
  },
  {
    id: 2,
    name: "discord-patlatma",
    description: "Discord Buton Patlatma/Nuke sistemi - Güçlü moderasyon aracı",
    language: "JavaScript",
    stars: 81,
    forks: 12,
    isPublic: true,
    url: "https://github.com/canervac/discord-patlatma",
    topics: ["discord", "bot", "moderation"]
  },
  {
    id: 3,
    name: "discord-buton-menu",
    description: "Discord Buton Menü | Sunucunuz daha gelişmiş ve olanaklı olmasını sağlayın!",
    language: "JavaScript",
    stars: 51,
    forks: 8,
    isPublic: true,
    url: "https://github.com/canervac/discord-buton-menu",
    topics: ["discord", "buttons", "menu"]
  },
  {
    id: 4,
    name: "discord-register-v12",
    description: "Public ve ekip sunucularında kullanılan profesyonel register botu",
    language: "JavaScript",
    stars: 50,
    forks: 7,
    isPublic: true,
    url: "https://github.com/canervac/discord-register-v12",
    topics: ["discord", "register", "verification"]
  },
  {
    id: 5,
    name: "dark-planet",
    description: "Karanlık gezegen temalı interaktif web projesi",
    language: "JavaScript",
    stars: 0,
    forks: 0,
    isPublic: true,
    url: "https://github.com/canervac/dark-planet",
    topics: ["web", "interactive", "3d"]
  },
  {
    id: 6,
    name: "discord-giweaway",
    description: "Basit ve etkili Discord çekiliş botu v12",
    language: "JavaScript",
    stars: 0,
    forks: 0,
    isPublic: true,
    url: "https://github.com/canervac/discord-giweaway",
    topics: ["discord", "giveaway", "bot"]
  }
];

export const technologies = [
  { name: "HTML", icon: "html", category: "Frontend", color: "#E34F26", level: 95 },
  { name: "CSS", icon: "css", category: "Frontend", color: "#1572B6", level: 90 },
  { name: "JavaScript", icon: "javascript", category: "Frontend", color: "#F7DF1E", level: 88 },
  { name: "TypeScript", icon: "typescript", category: "Frontend", color: "#3178C6", level: 82 },
  { name: "React", icon: "react", category: "Frontend", color: "#61DAFB", level: 85 },
  { name: "Next.js", icon: "nextjs", category: "Frontend", color: "#ffffff", level: 80 },
  { name: "Tailwind", icon: "tailwind", category: "Frontend", color: "#06B6D4", level: 92 },
  { name: "Bootstrap", icon: "bootstrap", category: "Frontend", color: "#7952B3", level: 78 },
  { name: "Python", icon: "python", category: "Backend", color: "#3776AB", level: 70 },
  { name: "PHP", icon: "php", category: "Backend", color: "#777BB4", level: 65 },
  { name: "MongoDB", icon: "mongodb", category: "Database", color: "#47A248", level: 75 },
  { name: "MySQL", icon: "mysql", category: "Database", color: "#4479A1", level: 72 }
];

export const experiences = [
  {
    id: 1,
    title: "Freelance Grafik Tasarımcı",
    company: "Serbest",
    period: "2023 - Günümüz",
    description: "Logo tasarımı, sosyal medya görselleri ve marka kimliği çalışmaları. Photoshop, Illustrator ve Blender gibi araçlarla profesyonel tasarımlar oluşturuyorum.",
    details: [
      "50+ marka kimliği ve logo tasarımı",
      "Sosyal medya kampanya görselleri",
      "3D modelleme ve render projeleri",
      "UI/UX tasarım danışmanlığı"
    ]
  },
  {
    id: 2,
    title: "Web Geliştirici",
    company: "Kişisel Projeler",
    period: "2023 - Günümüz",
    description: "React ve Next.js ile modern web uygulamaları geliştirme. Full-stack projeler üzerinde çalışarak kullanıcı dostu arayüzler tasarlıyorum.",
    details: [
      "React, Next.js ve TypeScript ile SPA geliştirme",
      "Tailwind CSS ile responsive tasarımlar",
      "REST API ve veritabanı entegrasyonları",
      "Discord bot geliştirme (JavaScript)"
    ]
  },
  {
    id: 3,
    title: "Motion Graphics Tasarımcı",
    company: "YouTube & Sosyal Medya",
    period: "2024 - Günümüz",
    description: "After Effects ile etkileyici motion graphics ve müzik görselleştirmeleri oluşturuyorum.",
    details: [
      "After Effects ile animasyon projeleri",
      "Müzik görselleştirme videoları",
      "YouTube içerik üretimi",
      "Video düzenleme ve post-prodüksiyon"
    ]
  }
];

export const gallery = [
  {
    id: 1,
    title: "Grafik Tasarım Çalışması",
    image: "https://www.canervac.com.tr/_next/image?url=%2Fimages%2Fprojects%2Fproject-01%2Fcanervac1.png&w=3840&q=75",
    category: "Tasarım"
  },
  {
    id: 2,
    title: "Web Projesi",
    image: "https://www.canervac.com.tr/_next/image?url=%2Fimages%2Fprojects%2Fproject-01%2Fwebsitesi1.png&w=3840&q=75",
    category: "Web"
  },
  {
    id: 3,
    title: "Ders Çalışma Uygulaması",
    image: "https://www.canervac.com.tr/_next/image?url=%2Fimages%2Fprojects%2Fproject-01%2Fstudent1.PNG&w=3840&q=75",
    category: "Web"
  },
  {
    id: 4,
    title: "Çalışma Alanım",
    image: "https://images.unsplash.com/photo-1632937145991-91620be68319?w=800&q=80",
    category: "Workspace"
  },
  {
    id: 5,
    title: "Kreatif Süreç",
    image: "https://images.unsplash.com/photo-1764740109279-c7a8abd78821?w=800&q=80",
    category: "Workspace"
  },
  {
    id: 6,
    title: "Geliştirme Ortamı",
    image: "https://images.unsplash.com/photo-1532623034127-3d92b01fb3c5?w=800&q=80",
    category: "Workspace"
  }
];

export const skills = [
  { name: "Web Geliştirme", percentage: 88 },
  { name: "UI/UX Tasarım", percentage: 85 },
  { name: "Grafik Tasarım", percentage: 90 },
  { name: "3D Modelleme", percentage: 70 },
  { name: "Motion Graphics", percentage: 75 }
];
